export default {
  computed: {
    locale() {
      return this.$i18n.locale;
    }
  }
}
